import React, { useRef, useEffect } from "react";
import "./Videos.scss";
import video2 from "../../assets/videos/video2.jpg";
import play from "../../assets/videos/play.png";
import Player from "@vimeo/player";

function Video2() {
  const poster = useRef();
  const video = useRef();

  const handleClickVideo = () => {
    poster.current.style.visibility = "hidden";
    video.current.play();
  };

  useEffect(() => {
    video.current = new Player("video2", {
      id: 243170928,
      controls: true,
      frameborder: "0",
      allow: "fullscreen; picture-in-picture",
      responsive: true,
    });
  }, []);

  useEffect(() => {
    video.current.on("ended", () => {
      poster.current.style.visibility = "visible";
    });
  });

  return (
    <section className="videos">
      <div className="videos__video">
        <div className="videos1__poster" ref={poster}>
          <img src={video2} alt="" className="videos1__poster__img" />
          <img
            src={play}
            alt="play"
            className="videos__play"
            onClick={handleClickVideo}
          />
        </div>
        <div data-vimeo-id="243170928" id="video2" className="video2" />
      </div>

      <p className="videos__video__title">LEGEND OF THE RUBY</p>
      <p className="videos__video__copy">
        Roberto Coin places a ruby on the inside of every piece of jewelry he
        designs. Inspired by the myths the ruby has engendered in cultures
        around the world, Roberto imbues each gem with the power of his own
        story and those that came before.
      </p>
    </section>
  );
}

export default Video2;
